// @flow
import React, { Component } from 'react';
import QuotingQuoteCards from 'containers/list/QuotingQuoteCards';
import QuotingTemplate from 'components/quoting/QuotingTemplate/QuotingTemplate';
import QuotingAbout from 'components/quoting/QuotingAbout/QuotingAbout';
import { Helmet } from 'react-helmet';
import ScrollToTop from 'components/common/ScrollToTop';
import type { ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Quoting extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <QuotingTemplate>
        <Helmet>
          <title>견적요청 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 따끈따끈한 견적요청들을 살펴보세요."
          />
        </Helmet>
        <QuotingAbout />
        <QuotingQuoteCards category={category} sort={sort} />
      </QuotingTemplate>
    );
  }
}

export default Quoting;



// WEBPACK FOOTER //
// ./src/pages/Quoting.js